import { render, staticRenderFns } from "./BidSheetUserInfo.vue?vue&type=template&id=3206744d&scoped=true&"
import script from "./BidSheetUserInfo.vue?vue&type=script&lang=js&"
export * from "./BidSheetUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./BidSheetUserInfo.vue?vue&type=style&index=0&id=3206744d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206744d",
  null
  
)

export default component.exports